import React from "react";
import {Helmet} from "react-helmet";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import 'bootstrap/dist/css/bootstrap.min.css';
import ApiService from '../../classes/ApiService';
import { Button} from "react-bootstrap";
import AppleSigninButton from "../ThirdPartySignIn/AppleSigninButton";
import FacebookLoginButton from "../ThirdPartySignIn/FacebookLoginButton";
import GoogleSigninButton from "../ThirdPartySignIn/GoogleSigninButton";
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom';
const GuestSignup = () => {
    const location = useLocation();
    const fullPath = `${window.location.origin}${location.pathname}`;
    const registrationContent = {
        header: "Registration Successful!",
        body: "Thank you for registering as a Guest on Rentid.",
        variant: "success",
    };
    const ToastContent = ({ header, body }) => (
        <div>
            <strong style={{ fontSize: "16px" }}>{header}</strong>
            <p style={{ margin: "5px 0 0" }}>{body}</p>
        </div>
    );
    
    const initialValues = {
        firstname: '',
        lastname: '',
        email: '',
        country: '',
        number: '',
        password: '',
        confirmPassword: '',
    };

    const validationSchema = Yup.object({
        firstname: Yup.string().required('First name is required'),
        lastname: Yup.string().required('Last name is required'),
        email: Yup.string().email('Invalid email format').required('Email is required'),
        country: Yup.string().required('Country is required'),
        number: Yup.string()
            .matches(/^\d+$/, 'Only digits are allowed')
            .required('Phone number is required'),
        password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm password is required'),
    });

    const handleSubmit = async (values) => {
        const apiService = new ApiService();
        const toastId = toast.loading("Submitting your registration..."); // Create a loading toast with an ID
    
        try {
            const response = await apiService.post('/registration/guest', {
                first_name: values.firstName,
                last_name: values.lastName,
                phone_number: values.number,
                email_address: values.email,
                password: values.password
            });
    
            if (response.success) {
                toast.update(toastId, {
                    render: <ToastContent header={registrationContent.header} body={registrationContent.body} />,
                    type: "success",
                    isLoading: false,
                    autoClose: 5000
                });
            } else {
                const errorMessage = response.data?.message || "Something went wrong.";
                toast.update(toastId, {
                    render: <ToastContent header="Error!" body={errorMessage} />,
                    type: "error",
                    isLoading: false,
                    autoClose: 5000
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An error occurred during registration.";
            toast.update(toastId, {
                render: <ToastContent header="Error!" body={errorMessage} />,
                type: "error",
                isLoading: false,
                autoClose: 5000
            });
        }
    };

    return (
        <section className="logMain">
            <Helmet>
                <title>RentId | Guest Signup</title>
                <meta property="og:title" content="Rentid | Guest Signup" />
                <meta name="twitter:title" content="Rentid | Guest Signup" />
                <meta name="description" content="Register With Rentid." />
                <meta name="twitter:description" content="Register With Rentid." />
                <meta property="og:description" content="Register With Rentid." />
                <meta name="keywords" content="Rent Success, Digital Back Office, Car Rental Support, Refund Policies, Insurance Claims Management, Cancellation Policies, Administrative Support, Guest Reporting, Rentid Resource Center, Rental Empowerment, Rental Guidelines" />
                <meta property="og:url" content="https://www.rentid.io/guest-signup" />
                <link rel="canonical" href="https://www.rentid.io/guest-signup" />
            </Helmet>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-12 logLeft">
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="logRight">
                            <div className="logRightInner">
                                <h1>Register With <span>Rentid</span></h1>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting }) => (
                                        <Form>
                                        <div className="row"> 
                                            <div className="col-lg-6 col-md-6"> 
                                                <div className="mb-3 form-group">
                                                <label htmlFor="firstname" className="form-label">First Name</label>
                                                <Field
                                                    type="text"
                                                    id="firstname"
                                                    name="firstname"
                                                    className="form-control"
                                                    disabled={isSubmitting}
                                                />
                                                <ErrorMessage name="firstname" component="div" className="text-danger" />
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="lastname" className="form-label">Last Name</label>
                                                    <Field
                                                        type="text"
                                                        id="lastname"
                                                        name="lastname"
                                                        className="form-control"
                                                        disabled={isSubmitting}
                                                    />
                                                    <ErrorMessage name="lastname" component="div" className="text-danger" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="email" className="form-label">Email</label>
                                                    <Field
                                                        type="email"
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        disabled={isSubmitting}
                                                    />
                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="number" className="form-label">Phone Number</label>
                                                    <Field
                                                        type="text"
                                                        id="number"
                                                        name="number"
                                                        className="form-control"
                                                        disabled={isSubmitting}
                                                    />
                                                    <ErrorMessage name="number" component="div" className="text-danger" />
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="password" className="form-label">Password</label>
                                                    <Field
                                                        type="password"
                                                        id="password"
                                                        name="password"
                                                        className="form-control"
                                                        disabled={isSubmitting}
                                                    />
                                                    <ErrorMessage name="password" component="div" className="text-danger" />
                                                        <div className="errorMessageGuest d-none">
                                                            <ul>
                                                                <li>
                                                                    <img width="14px" height="14px" src="/img/check_green.svg" alt="check" />
                                                                    <span>At least 8 characters</span>
                                                                </li>
                                                                <li>
                                                                    <img width="14px" height="14px" src="/img/check_green.svg" alt="check" />
                                                                    <span>At least 1 uppercase letter</span>
                                                                </li>
                                                                <li>
                                                                    <img width="14px" height="14px" src="/img/check_green.svg" alt="check" />
                                                                    <span>At least 1 lowercase letter</span>
                                                                </li>
                                                                <li>
                                                                    <img width="14px" height="14px" src="/img/check_green.svg" alt="check" />
                                                                    <span>At least 1 lowercase Number</span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                                                    <Field
                                                        type="password"
                                                        id="confirmPassword"
                                                        name="confirmPassword"
                                                        className="form-control"
                                                        disabled={isSubmitting}
                                                    />
                                                    <ErrorMessage name="confirmPassword" component="div" className="text-danger" />
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12"> 
                                                <div className="mb-3 form-group">
                                                    <label htmlFor="country" className="form-label">Country or Regin</label>
                                                    <Field
                                                        as="select"
                                                        id="country"
                                                        name="country"
                                                        className="form-select"
                                                        disabled={isSubmitting}
                                                    >
                                                        <option value="">Select Country</option>
                                                        <option value="USA">USA</option>
                                                        <option value="Canada">Canada</option>
                                                        <option value="India">India</option>
                                                    </Field>
                                                    <ErrorMessage name="country" component="div" className="text-danger" />
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12"> 
                                                <Button type="submit" className="btn w-100 btnBlue" disabled={isSubmitting}>
                                                    Sign Up
                                                </Button>
                                            </div>


                                            <div className="col-lg-12 col-md-12"> 
                                                <div className="or">
                                                    <span>Or</span>
                                                </div>
                                            </div>

                                                <div className="col-lg-12 col-md-12">
                                                    <div className="continueLogin">
                                                        <ul>
                                                            <li>
                                                                <GoogleSigninButton register={true} type="guest" redirect_uri={fullPath}/>
                                                            </li>
                                                            <li>
                                                                <AppleSigninButton type="guest"/>
                                                            </li>
                                                            <li >
                                                                <FacebookLoginButton type="guest"/>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            <div className="col-lg-12 col-md-12"> 
                                                <div className="descLogin">
                                                    <p>By continuing, you agree to Rentid's Terms of Service and acknowledge you've read our Privacy Policy</p>
                                                    <p>Already have an account? <a href="/guest">Login</a></p>
                                                </div>
                                            </div>
                                        </div>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GuestSignup;
